import login from '../../Actions/captcha';
const { types } = login;

const initialState = {
    status:''
};

const captchaReducer = (state = initialState, action) => {    
    switch (action.type) {	
        case types.UPDATE_CAPTCHA:
			return {
				...state,
				status: action.status
            }        
        default:
            return state;
    }
}

export default captchaReducer;